module.exports = __webpack_public_path__ + "img/tzs-sharetip.ba730307.png";